export default __webpack_public_path__ + "static/media/Night.45d6f5d1.svg";